var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tags-input-root", staticStyle: { position: "relative" } },
    [
      _c(
        "div",
        {
          class:
            ((_obj = {}),
            (_obj[_vm.wrapperClass + " tags-input"] = true),
            (_obj["active"] = _vm.isActive),
            (_obj["disabled"] = _vm.disabled),
            _obj)
        },
        [
          _vm._l(_vm.tags, function(tag, index) {
            return _c(
              "span",
              {
                key: index,
                staticClass:
                  "tags-input-badge tags-input-badge-pill tags-input-badge-selected-default",
                class: { disabled: _vm.disabled }
              },
              [
                _vm._t(
                  "selected-tag",
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(tag[_vm.textField]) }
                    }),
                    _c("a", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.disabled,
                          expression: "!disabled"
                        }
                      ],
                      staticClass: "tags-input-remove",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeTag(index)
                        }
                      }
                    })
                  ],
                  { tag: tag, index: index, removeTag: _vm.removeTag }
                )
              ],
              2
            )
          }),
          _c("input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hideInputField,
                expression: "!hideInputField"
              }
            ],
            ref: "taginput",
            attrs: {
              type: "text",
              id: _vm.inputId,
              name: _vm.inputId,
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.input },
            on: {
              input: function(e) {
                return (_vm.input = e.target.value)
              },
              compositionstart: function($event) {
                _vm.composing = true
              },
              compositionend: function($event) {
                _vm.composing = false
              },
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.tagFromInput(false)
                },
                function($event) {
                  if (!$event.type.indexOf("key") && $event.keyCode !== 8) {
                    return null
                  }
                  return _vm.removeLastTag($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  return _vm.nextSearchResult($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  return _vm.prevSearchResult($event)
                },
                _vm.onKeyDown
              ],
              keyup: [
                _vm.onKeyUp,
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.clearSearchResults($event)
                }
              ],
              focus: _vm.onFocus,
              click: _vm.onClick,
              blur: _vm.onBlur,
              value: _vm.tags
            }
          }),
          _vm.elementId
            ? _c(
                "div",
                { staticStyle: { display: "none" } },
                _vm._l(_vm.tags, function(tag, index) {
                  return _c("input", {
                    key: index,
                    attrs: { type: "hidden", name: _vm.elementId + "[]" },
                    domProps: { value: _vm.hiddenInputValue(tag) }
                  })
                }),
                0
              )
            : _vm._e()
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchResults.length,
              expression: "searchResults.length"
            }
          ]
        },
        [
          _vm.typeaheadStyle === "badges"
            ? _c(
                "p",
                { class: "typeahead-" + _vm.typeaheadStyle },
                [
                  !_vm.typeaheadHideDiscard
                    ? _c("span", {
                        staticClass:
                          "tags-input-badge typeahead-hide-btn tags-input-typeahead-item-default",
                        domProps: {
                          textContent: _vm._s(_vm.discardSearchText)
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.clearSearchResults(true)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._l(_vm.searchResults, function(tag, index) {
                    return _c("span", {
                      key: index,
                      staticClass: "tags-input-badge",
                      class: {
                        "tags-input-typeahead-item-default":
                          index != _vm.searchSelection,
                        "tags-input-typeahead-item-highlighted-default":
                          index == _vm.searchSelection
                      },
                      domProps: { innerHTML: _vm._s(tag[_vm.textField]) },
                      on: {
                        mouseover: function($event) {
                          _vm.searchSelection = index
                        },
                        mousedown: function($event) {
                          $event.preventDefault()
                          return _vm.tagFromSearchOnClick(tag)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm.typeaheadStyle === "dropdown"
            ? _c(
                "ul",
                { class: "typeahead-" + _vm.typeaheadStyle },
                [
                  !_vm.typeaheadHideDiscard
                    ? _c("li", {
                        staticClass:
                          "tags-input-typeahead-item-default typeahead-hide-btn",
                        domProps: {
                          textContent: _vm._s(_vm.discardSearchText)
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.clearSearchResults(true)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._l(_vm.searchResults, function(tag, index) {
                    return _c("li", {
                      key: index,
                      class: {
                        "tags-input-typeahead-item-default":
                          index != _vm.searchSelection,
                        "tags-input-typeahead-item-highlighted-default":
                          index == _vm.searchSelection
                      },
                      domProps: { innerHTML: _vm._s(_vm.getDisplayField(tag)) },
                      on: {
                        mouseover: function($event) {
                          _vm.searchSelection = index
                        },
                        mousedown: function($event) {
                          $event.preventDefault()
                          return _vm.tagFromSearchOnClick(tag)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }